import { useRbacConfig } from '@/shared/features/rbac/context/rbac-config-context';
import { useOwnUserRoles } from '@/shared/features/rbac/hooks/use-own-user-roles/use-own-user-roles';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const useLoggedInUser = () => {
  const user = useAppSelector(selectUser);
  const { useTenantSettings } = useRbacConfig();
  const { ownerId, isLoadingTenant } = useTenantSettings();
  // The permission provider already holds the own-user roles; reading them by
  // userId here was a second, identical policies request on every login.
  const { roles, isLoading: isLoadingPolicies } = useOwnUserRoles();
  const policies = roles.flatMap(({ policies }) => policies);
  const isAdmin = policies?.some(
    ({ action, resource }) =>
      action.every((a) => a === '*') && resource.every((r) => r === '*'),
  );

  const canViewPage = (type: string) => {
    return policies?.some(
      ({ action }) =>
        action.every((a) => a === '*') ||
        action.every((a) => a.startsWith(type)),
    );
  };

  const isSsoUser = Boolean(user?.attributes?.identities?.length);
  const isMfaEnabled = Boolean(user?.mfaEnabled);
  const isLoggedInUser = (userId?: string) => user?.userId === userId;
  const isOwner = (userId?: string) => userId === ownerId;
  const isLoading = isLoadingPolicies || isLoadingTenant;

  return {
    isAdmin,
    isSsoUser,
    isMfaEnabled,
    isLoading,
    isOwner,
    isLoggedInUser,
    loggedInUser: user,
    canViewPage,
  };
};
